import { Event } from '../types';

export class DatabaseContentIdChanged extends Event<void> {}
